module.exports = __webpack_public_path__ + "img/company_bg.e0297749.png";